/**
 * Main application charts
 */
import "./style.css";
import MDBox from "components/Basics/MDBox";
import DashboardLayout from "components/Advanced/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Advanced/Navbars/DashboardNavbar";
import { useState } from "react";
import { Icon, Tab, Tabs } from "@mui/material";
import ChangesTab from "./components/Changes";
import RightPannel from "./components/RightPannel";
import MappingTab from "./components/Mapping";
import TemplateTab from "./components/Template";
import BijectionTab from "./components/Bijection";

/**
 */
export default function DeploymentPage({ route }) {
	const [openPannel, setOpenPannel] = useState(false);
	const [pannelContent, setPannelContent] = useState(null);

	const [tab, setTab] = useState(0);

	const changePannelContent = content => {
		setPannelContent(content);
		setOpenPannel(true);
	};

	const closePannel = () => {
		setOpenPannel(false);
		setPannelContent(null);
	};

	const getTabContent = () => {
		switch (tab) {
			case 0:
				return <TemplateTab />;
			case 1:
				return <BijectionTab />;
			// case 0:
			// 	return <MappingTab />;
			// case 1:
			// 	return <TemplateTab />;
			// case 3:
			// 	return <ChangesTab changePannelContent={changePannelContent} />;
			default:
				return null;
		}
	};

	return (
		<DashboardLayout style={{ height: "100%" }} display="flex">
			<DashboardNavbar
				filters={[
					<MDBox>
						<Tabs
							orientation="horizontal"
							value={tab}
							onChange={(e, v) => {
								setTab(v);
							}}
						>
							{/* <Tab
								sx={{
									fontSize: "0.75rem"
								}}
								label="Mapping"
								icon={
									<Icon fontSize="small" sx={{ mt: -0.25 }}>
										move_up
									</Icon>
								}
							/> */}
							<Tab
								sx={{
									fontSize: "0.75rem"
								}}
								label="Template"
								icon={
									<Icon fontSize="small" sx={{ mt: -0.25 }}>
										article
									</Icon>
								}
							/>
							<Tab
								sx={{
									fontSize: "0.75rem"
								}}
								label="Bijection mongo/vecteurs"
								icon={
									<Icon fontSize="small" sx={{ mt: -0.25 }}>
										article
									</Icon>
								}
							/>
							{/* <Tab
								sx={{
									fontSize: "0.75rem"
								}}
								label="Deployment"
								icon={
									<Icon fontSize="small" sx={{ mt: -0.25 }}>
										settings
									</Icon>
								}
							/>
							<Tab
								sx={{
									fontSize: "0.75rem"
								}}
								label="Changes"
								icon={
									<Icon fontSize="small" sx={{ mt: -0.25 }}>
										compare_arrows
									</Icon>
								}
							/> */}
						</Tabs>
					</MDBox>
				]}
			/>
			<MDBox
				className="pageContentContainer"
				style={{
					display: openPannel ? "flex" : "block"
				}}
			>
				<MDBox flex="1">{getTabContent()}</MDBox>

				{openPannel && pannelContent && (
					<RightPannel closePannel={closePannel} content={pannelContent} />
				)}
			</MDBox>
		</DashboardLayout>
	);
}
